function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5528 10.1961C12.3666 10.1961 12.1805 10.1249 12.0386 9.98308C11.7542 9.69878 11.7542 9.23909 12.0386 8.95479L13.5077 7.48571C14.1775 6.82242 14.5455 5.93661 14.5455 4.98901C14.5455 3.04068 12.96 1.45456 11.011 1.45456C10.0641 1.45456 9.17827 1.82249 8.51657 2.49018L7.04524 3.96138C6.76093 4.24582 6.30125 4.24582 6.01694 3.96138C5.73263 3.67707 5.73263 3.21739 6.01694 2.93308L7.48601 1.46335C8.42123 0.520807 9.67364 0 11.011 0C13.7622 0 16 2.23783 16 4.98901C16 6.32785 15.4792 7.57946 14.5331 8.51694L13.0663 9.98308C12.9245 10.1249 12.739 10.1961 12.5528 10.1961Z",
  fill: "inherit"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.98901 15.9998C2.23783 15.9998 0 13.7619 0 11.0108C0 9.67193 0.520807 8.42032 1.46694 7.48284L2.93375 6.0167C3.21819 5.73239 3.67774 5.73239 3.96218 6.0167C4.24649 6.301 4.24649 6.76069 3.96218 7.04499L2.49311 8.51406C1.82249 9.17736 1.45456 10.0632 1.45456 11.0108C1.45456 12.9591 3.04001 14.5452 4.98901 14.5452C5.93594 14.5452 6.82175 14.1773 7.48345 13.5096L8.95479 12.0384C9.23909 11.754 9.69878 11.754 9.98308 12.0384C10.2674 12.3227 10.2674 12.7824 9.98308 13.0667L8.51401 14.5366C7.5788 15.479 6.32652 15.9998 4.98901 15.9998Z",
  fill: "inherit"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.54183 7.18517C9.35567 7.18517 9.1695 7.11393 9.02768 6.97211C8.74338 6.6878 8.74338 6.22812 9.02768 5.94381L10.3949 4.57661C10.6793 4.29217 11.1389 4.29217 11.4233 4.57661C11.7076 4.86092 11.7076 5.3206 11.4233 5.60491L10.056 6.97211C9.91416 7.11393 9.728 7.18517 9.54183 7.18517Z",
  fill: "inherit"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M5.09076 11.6361C4.9046 11.6361 4.7183 11.5649 4.57661 11.4231C4.29217 11.1386 4.29217 10.6791 4.57661 10.3946L5.94381 9.02744C6.22812 8.74313 6.6878 8.74313 6.97211 9.02744C7.25655 9.31174 7.25655 9.77143 6.97211 10.0557L5.60491 11.4231C5.46309 11.5649 5.27692 11.6361 5.09076 11.6361Z",
  fill: "inherit"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M15.2725 16.0018C15.0863 16.0018 14.9002 15.9306 14.7584 15.7887L0.21333 1.24358C-0.0711098 0.959273 -0.0711098 0.499589 0.21333 0.215283C0.497636 -0.0691568 0.957186 -0.0691568 1.24163 0.215283L15.7868 14.7603C16.0711 15.0448 16.0711 15.5043 15.7868 15.7887C15.645 15.9306 15.4587 16.0018 15.2725 16.0018Z",
  fill: "inherit"
});

var SvgIconUnlink = function SvgIconUnlink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "white",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconUnlink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-unlink.0fc89a8a.svg";
export { ForwardRef as ReactComponent };